import { render } from "./BaseSelectField.vue?vue&type=template&id=1d6fc783&scoped=true"
import script from "./BaseSelectField.vue?vue&type=script&lang=js"
export * from "./BaseSelectField.vue?vue&type=script&lang=js"

import "./BaseSelectField.vue?vue&type=style&index=0&id=1d6fc783&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6fc783"]])

export default __exports__